import { Box, Container, Divider, Grid, Typography } from '@mui/material'
import React from 'react';
import './App.css';
import Balance from './Components/Balance';

function App() {
  
  return (
    <Container>
      <Box>
      <Grid container>

      <Grid item xs={12} sm={12}>
        <Typography variant='h3' textAlign={'center'}>Expense Tracker App</Typography>
      </Grid>

      <Divider></Divider>
      
      <Balance></Balance>
      </Grid>
      </Box>
    </Container>
  );
}

export default App;
